import { FaWhatsapp, FaInstagram } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="relative overflow-hidden bg-zinc-950 text-white">
            <div
                className="pointer-events-none absolute inset-x-0 top-0 h-20"
                aria-hidden="true"
                style={{
                    background:
                        "linear-gradient(to bottom, rgba(9,9,11,0) 0%, rgba(9,9,11,0.88) 70%, rgba(9,9,11,1) 100%)",
                }}
            />
            <div
                className="pointer-events-none absolute inset-0 opacity-60"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 12% 85%, rgba(253, 191, 4, 0.15), transparent 36%), radial-gradient(circle at 90% 12%, rgba(234, 179, 8, 0.10), transparent 33%)",
                }}
            />
            <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-10 sm:px-6">
                <div className="mb-8 flex flex-col gap-2 text-center sm:text-left">
                    <h3 className="text-2xl font-bold">
                        Cat<span className="text-yellow-cdg">Pass</span>
                    </h3>
                    <p className="max-w-2xl font-sans text-sm text-zinc-300">
                        Comprá tus entradas oficiales y accedé rápido a tus tickets digitales.
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm">
                        <h4 className="mb-3 text-lg font-semibold">Contacto</h4>
                        <p className="mb-3 font-sans text-sm text-zinc-300">
                            WhatsApp para reclamos de 11:00 a 18:00:
                            <br />
                            +54 9 2355 55-0176
                        </p>
                        <a
                            href="https://api.whatsapp.com/send?phone=5492355550176&text=Hola%20vengo%20de%20Catpass%20y%20mi%20consulta%20es..."
                            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-emerald-400 to-emerald-500 px-3 py-2 font-sans text-sm font-medium text-white shadow-[0_10px_22px_rgba(52,211,153,0.25)] transition-transform hover:scale-[1.02]"
                        >
                            <FaWhatsapp className="text-base" />
                            Escribir por WhatsApp
                        </a>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm">
                        <h4 className="mb-3 text-lg font-semibold">Redes</h4>
                        <p className="mb-3 font-sans text-sm text-zinc-300">
                            Consultas e información general.
                        </p>
                        <div className="flex flex-wrap gap-2 font-sans text-sm text-zinc-300">
                            <a
                                href="https://www.instagram.com/ciudaddegatos/"
                                className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-fuchsia-400 to-violet-500 px-3 py-2 font-medium text-white shadow-[0_10px_22px_rgba(192,132,252,0.25)] transition-transform hover:scale-[1.02]"
                            >
                                <FaInstagram />
                                Instagram
                            </a>
                        </div>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm">
                        <h4 className="mb-3 text-lg font-semibold">Desarrollador</h4>
                        <p className="font-sans text-sm text-zinc-300">
                            Desarrollado por{" "}
                            <a href="https://passevent.site" className="font-semibold text-white">
                                Pass<span className="text-rose-500">Event</span>
                            </a>
                        </p>
                        <a
                            href="https://instagram.com/passevent.ar"
                            className="mt-3 inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-fuchsia-400 to-violet-500 px-3 py-2 font-sans text-sm font-medium text-white shadow-[0_10px_22px_rgba(192,132,252,0.25)] transition-transform hover:scale-[1.02]"
                        >
                            <FaInstagram />
                            @passevent.ar
                        </a>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm">
                        <h4 className="mb-3 text-lg font-semibold">Legales</h4>
                        <a
                            href="/terminos-y-condiciones.html"
                            className="block font-sans text-sm text-zinc-300 transition-colors hover:text-yellow-cdg"
                        >
                            Términos y condiciones
                        </a>
                        <a
                            href="/politica-de-privacidad.html"
                            className="mt-2 block font-sans text-sm text-zinc-300 transition-colors hover:text-yellow-cdg"
                        >
                            Políticas de privacidad
                        </a>
                    </div>

                </div>

                <div className="mt-6 rounded-2xl border border-zinc-800 bg-zinc-900/45 p-4 text-center backdrop-blur-sm">
                    <h4 className="mb-1 text-base font-semibold">Derechos</h4>
                    <p className="font-sans text-sm text-zinc-300">
                        &copy; {new Date().getFullYear()} Catpass. Todos los derechos reservados.
                    </p>
                </div>

                <div className="mt-6 border-t border-zinc-800/70 pt-4 text-center font-sans text-xs text-zinc-500">
                    Hecho para conectar personas con eventos en todo momento.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
